import React, { useContext } from 'react';
import classnames from 'classnames';
import { filter, includes, map, compact, flatten } from 'lodash';
import { FocusBaseContext } from '../contexts';
import Dropdown from '../../../common/dropdown';

const Header = () => {
  const { focus, onChangeDemos, onChangeFilters, currentSummary } = useContext(FocusBaseContext);

  const currentDemos = filter(
    focus.demos, (el) => includes(currentSummary.demos, el.value)
  );

  const currentFilters = compact(
    flatten(
      map(
        focus.filters,
        (el) => filter(
          el.options || [],
          (item) => includes(currentSummary.filter, item.value)
        )
      )
    )
  );
  return (
    <div className="page-header">
      <div className="page-header_content">
        <h1 className="page-header_title">
          <svg className="icon -i-tool-swipe-markup -small page-header_title_icon">
            <use xlinkHref="#svg_i-tool-swipe-markup" />
          </svg>
          { focus.title }
          <div className="small page-header_title_desc">
            { focus.visible_kind }
          </div>
        </h1>
      </div>
      <div className="page-header_controls">
        <div className="page-header_status">
          Status:
          { ' ' }
          <strong
            className={
              classnames(
                "page-header_status_text",
                { '-published': focus.published },
                { '-unpublished': !focus.published }
              )
            }
          >
            { focus.published ? 'Published' : 'Unpublished' }
          </strong>
        </div>
        <div className="page-header_controls_field -filter">
          <div className="top-section cols left-aligned demos">
            <span className="title">Demos:</span>
            <Dropdown
              value={ currentDemos }
              searchable
              multi
              options={ focus.demos }
              onChange={ onChangeDemos }
            />
          </div>
          <div className="top-section cols left-aligned filter">
            <span className="title">Filters:</span>
            <Dropdown
              value={ currentFilters }
              searchable
              multi
              options={ focus.filters }
              onChange={ onChangeFilters }
            />
          </div>
        </div>
      </div>
    </div>

  );
};

export default Header;
